import type { OpenWebViewAlwaysOnTop, ShowSyncboxRequestPayload } from '@sdk/payload.types'
import { highLevelApi } from '@sdk/main'

export function close() {
  return highLevelApi.API.request('close') //`this` reference is lost on a new WebView
}

export function openWebViewAlwaysOnTop(payload: OpenWebViewAlwaysOnTop): Promise<void> {
  return this.API.request('open_web_view_always_on_top', payload)
}

export function showSyncbox(payload: ShowSyncboxRequestPayload): Promise<void> {
  return this.API.request('show_syncbox', payload)
}
